<script lang="ts" setup>
import useThemeVars from '@lib/composables/useThemeVars'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useI18n } from 'vue-i18n'
import { getComponentTitle } from '@canvas-builder/util/canvas.util'

interface Props {
  name?: string
}

defineProps<Props>()
const themeVars = useThemeVars()
const { t } = useI18n()

const getParsedName = (name?: string) => {
  let parsedName = ''

  if (name) {
    parsedName = getComponentTitle(name, t) || name.trim()
  }

  return parsedName || t('canvasUI.canvasBuilder.placeholderComponent.defaultName')
}
</script>

<template>
  <div class="placeholder-component flex flex-col items-center rounded-2 px-4 py-8 text-center font-size-[14px]">
    <CIcon class="mb-2" :color="themeVars.primary4" icon="lock" size="24" />
    {{
      t('canvasUI.canvasBuilder.placeholderComponent.description', {
        name: getParsedName(name),
      })
    }}
  </div>
</template>

<style lang="scss" scoped>
.placeholder-component {
  background: v-bind('themeVars.primary6');
  color: v-bind('themeVars.text');
  border: 1px solid v-bind('themeVars.primary5');
}
</style>
